import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=331573b7&scoped=true&"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=331573b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331573b7",
  null
  
)

export default component.exports